import React, { useEffect, useState } from "react";
import "../pages/TakashiPlayground.css";

const CustomCursor = ({ isHoveringPhone }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [clicking, setClicking] = useState(false);


    
    useEffect(() => {
        const moveCursor = (e) => {
            setPosition(prev => 
                prev.x !== e.clientX || prev.y !== e.clientY 
                    ? { x: e.clientX, y: e.clientY } 
                    : prev
            );
        };
        

        const handleMouseDown = () => setClicking(true);
        const handleMouseUp = () => setClicking(false);

        window.addEventListener("mousemove", moveCursor);
        window.addEventListener("mousedown", handleMouseDown);
        window.addEventListener("mouseup", handleMouseUp);

        return () => {
            window.removeEventListener("mousemove", moveCursor);
            window.removeEventListener("mousedown", handleMouseDown);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);

    return (
        <div
            className={`custom-cursor ${clicking ? "clicking" : ""} ${isHoveringPhone ? "visible" : "hidden"}`}
            style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
            }}
        ></div>
    );
};

export default CustomCursor;
